enum CompanyType {
  Agency = 'agency',
  Customer = 'customer',
  NorthernCables = 'northernCables',
}

export default CompanyType;
